import { FC } from "react";

import { IRenderColumnTemplate } from "./_core";
import { TextCellTemplate } from "./text-cell.template";

export const AddressCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  ...props
}) => {
  const mergedProps = {
    ...props,
    valueTranslated: props?.formAttributes?.isCoordinate
      ? value?.fullAddress
      : value,
  };

  return <TextCellTemplate value={value} {...mergedProps} />;
};
